export function fetchTodos(user_id) {
  return fetch(`${process.env.REACT_APP_USERDATA_URI}/todos/${user_id}`)
    .then(res => res.json())
    .then(payload => {
      if (!payload) throw new Error("No todos found");
      return payload;
    });
}

export function updateTodos(user_id, payload) {
  return fetch(
    `${process.env.REACT_APP_USERDATA_URI}/update/todos/${user_id}`,
    {
      method: "POST",
      body: JSON.stringify(payload)
    }
  ).then(res => res.json());
}

export function updateReminders(user_id, payload) {
  return fetch(
    `${process.env.REACT_APP_USERDATA_URI}/update/reminders/${user_id}`,
    {
      method: "POST",
      body: JSON.stringify(payload)
    }
  ).then(res => res.json());
}

export default {
  fetchTodos,
  updateTodos,
  updateReminders
};



// WEBPACK FOOTER //
// ./src/api/todos/index.js